import React, { useEffect } from "react";
import webDevData from "./WebDevData";
import AccordComp from "../TempComponent/TempComponents";
import Main from "../../../Main/Main";
function WebDev({ title }) {
  useEffect(() => {
    document.title = title;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, [title]);
  return (
    <div>
      <Main
        heading="Web Development"
        description="Making Sure Your Business Reaches New Heights"
      />
      <AccordComp
        imgSrc="https://<strong>navishsol</strong>.com/wp-content/uploads/2020/06/web-development-img-min.png"
        AccordData={webDevData}
      />
    </div>
  );
}

export default WebDev;
